<div class="cntner">
    <div class="img">
      <img class="imgOne" src="../../assets/Image/analyticFavIcon.png" alt="404" />
    </div>
    <h1>404</h1>
    <p class="message">Oops! Page Not Found</p>
    <div class="quote-container">
      <p class="quote" [innerText]="currentQuote"></p>
    </div>
  </div>